import HighlightedSpecsRes from '../../../../../pages/vip/features/highlighted-specs-res/index';

export default HighlightedSpecsRes;
